import React from 'react';
import { formatMessageContent } from './FormattedMessageContent.utils'
import styles from './FormattedMessageContent.module.css';
import { MessageSection } from './FormattedMessageContent.types';

const FormattedMessageContent: React.FC<{ content: string }> = ({ content }) => {
  const formattedContent: MessageSection[] = formatMessageContent(content);

  return (
    <div className={styles.formattedContent}>
      {formattedContent.map((section, index) => (
        <div key={index}>
          {section.type === 'paragraph' && (
            <p className={styles.messageParagraph}>{section.content}</p>
          )}
          {section.type === 'list' && (
            <ul className={styles.messageList}>
              {section.items.map((item, itemIndex) => (
                <li key={itemIndex} className={styles.messageListItem}>
                  {item}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
};

export default FormattedMessageContent;